import Vue from 'vue'
import { Transfer,Message,Collapse,CollapseItem,Carousel,CarouselItem,Button,Loading,InputNumber,Badge,Step,Steps,Popover, Checkbox, CheckboxGroup, Dialog, MessageBox, Radio, Select, Option, DatePicker, TimePicker, Switch, Progress,Tooltip,Notification,Tree} from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
export default function elementUi () {
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dialog)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Radio)
  Vue.use(Progress)
  Vue.use(DatePicker)
  Vue.use(TimePicker)
  Vue.use(Switch)
  Vue.use(Tooltip)
  Vue.use(Popover)
  Vue.use(Carousel)
  Vue.use(CarouselItem)
  Vue.use(Button)
  Vue.use(InputNumber)
  Vue.use(Step)
  Vue.use(Steps)
  Vue.use(Tree)
  Vue.use(Badge)
  Vue.use(Transfer)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  Vue.use(Loading.directive);
  Vue.prototype.$message = Message
  Vue.prototype.$msgbox = MessageBox
  Vue.component('el-collapse-transition', CollapseTransition)
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$notify = Notification;
}



// WEBPACK FOOTER //
// ./src/jvsit/common/element-ui.js